
import Node from "slotworks/state-machine/data/node";
/**
 * Marks a link as one which leads to another node (state, decision or super state),
 * or a named exit of it's parent node (EG: super state custom exits)
 */
export const enum LINK_TYPE { Node, Alias }

export default class Link {
    // Identifier
    public id: string;
    // Node this link leads to (if applicable)
    public node: Node;
    // Link to a node or an alias
    public type: LINK_TYPE;

    constructor(value: string | Node) {
        if (typeof value === "string") {
            this.type = LINK_TYPE.Alias;
            this.id = value;
        } else {
            this.type = LINK_TYPE.Node;
            this.node = value;
        }
    }
}
